<template>
    <div class="container">
        <div class="container__header">
            <div class="container__header-icon__wrapper">
                <SvgIcon class="container__header-icon" :name="props.iconName" />
            </div>
            <h4 class="title uppercase-first-letter container__header-title">
                <span v-if="props.title">{{ $t(`${props.title}`) }}</span>
                <span v-if="props.name">: {{ props.name }}</span>
            </h4>
        </div>

        <UIContainerMenu
            v-if="props.subMenu"
            :menu-item="props.subMenu"
        />

        <div class="container__content">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'UIContainer',
};
</script>

<script setup>
import SvgIcon from '@/components/ui/SvgIcon/index.vue';
import UIContainerMenu from '@/components/UIContainerMenu/index.vue';

const props = defineProps({
    title: { type: String, required: true, default: '' },
    name: { type: String, default: '' },
    iconName: { type: String, default: '' },
    subMenu: { type: [Array, Boolean], default: () => []},
    loading: { type: Boolean, default: false },
});

</script>
